import { Outlet } from "react-router";

const Settings = () => {
  return <Outlet />;
};

export default Settings;
